var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LayoutWrap',{staticClass:"mobile-layout-container"},[_c('MobileHeader'),_vm._v(" "),_c('PageWrap',{staticClass:"mobile-page-wrap"},[_c('Nuxt')],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }